import { useSyncExternalStore } from 'react';

import { subscribeInstallGuide, getInstallGuideSnapshot } from 'src/utils/pwa-install';

/** Stato della guida all'installazione: { promptAvailable, open }. */
export function useInstallGuide() {
  return useSyncExternalStore(subscribeInstallGuide, getInstallGuideSnapshot);
}
